import { GridContainer, Grid } from "@trussworks/react-uswds";
import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { logPageView } from "../utils/analytics";
import { handlePageLoad } from "../utils/accessibility";
import ResultDatum from "../components/ResultDetail/ResultDatum";
import { ReactComponent as Clock } from "../images/clock.svg";
import { ReactComponent as Telephone } from "../images/phone.svg";
import { ReactComponent as Website } from "../images/website.svg";
import WebsiteLink from "../components/ResultDetail/WebsiteLink";
import BackButton from "../components/BackButton";
import ReactMarkdown from "react-markdown";

function N988line() {
  useEffect(() => {
    handlePageLoad();
    logPageView();
  }, []);
  const location = useLocation();

  let { prevSearch } = (location.state ?? {}) as {
    prevSearch?: string;
  };
  const { t } = useTranslation();
  return (
    <GridContainer className="nice_font ResultDetail">
      <div className="margin-y-2 display-flex flex-justify">
        <BackButton 
          text={t("backToSearch")}
          href={`/search${prevSearch ?? ""}`}
        />
      </div>
      <Grid row className="flex-justify flex-align-baseline margin-bottom-2" >
        <h1 className="margin-top-2 margin-bottom-0 text-focus-no-outline">{t("988-line")}</h1>
      </Grid>
      <br></br>
      <Grid row>
        <Grid
            tablet={{ col: 6 }}
            className="padding-0 tablet:padding-x-1 order-last order-md-first nice_font"
          >
          <ReactMarkdown className="nice_font plain_link">{t("988-line-info")}</ReactMarkdown>
          <ResultDatum
            Icon={Telephone}
            iconClassName="margin-top-05"
            className="margin-y-0"
            key="telephone"
          >
            <div >
              <h3 className="usa-sr-only">{t("telephoneNumber")}</h3>
              <a href='tel:988' target="_blank" className="usa-link usa-link--external text-wrap">
                988
              </a>
            </div>
          </ResultDatum>
          <ResultDatum
            Icon={Website}
            className="margin-y-0"
            key="website"
          >
            <h3 className="usa-sr-only">{t("website")}</h3>
            <WebsiteLink url={t("988-line-url")} />
          </ResultDatum>
          <ResultDatum Icon={Clock} key="hours">
            <h3 className="font-body-sm margin-top-0 margin-bottom-05">
              {t("hours")}
            </h3>
            Open 24 hours
          </ResultDatum>
        </Grid>
      </Grid>
    </GridContainer>
  );
}

export default N988line;
